const leedpulse = {
  route_url: import.meta.env.VITE_LEEDPULSE_API_URL,
  activation_code_payment: [
    'LEEDGO2025',     // Code demandé par Clément le 30 juin 2025 (Septeo)
    'LEEDPULSE26',    // Code demandé par Romain le 2 juillet 2025 : webi du 8 juillet 2025 & du 31 juillet 2025
    'LEEDGOEXT'       // Code demandé par Clément le 4 juillet 2025 : tracking des commerciaux Septeo
  ]
};

export default leedpulse;
